import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import PromotionDialog from "@/components/extranet/PromotionDialog";
import { PROMO_TYPES } from "@/components/extranet/PromoTypes";

export default function BulkPromo({ properties = [], t }) {
  const [kind, setKind] = useState("basic_deal");
  const [all, setAll] = useState(true);
  const [sel, setSel] = useState([]);
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(null);
  const ids = all ? properties.map((p) => p.id) : sel;
  const toggle = (id, v) => setSel(v ? [...sel, id] : sel.filter((x) => x !== id));
  return (
    <div className="grid gap-4 p-5" data-testid="bulk-promo">
      <p className="text-sm text-slate-600">{t("Buat satu promosi sekaligus di semua properti atau properti pilihan. Promosi berlaku untuk semua tipe kamar & rate plan di tiap properti, dan setelah dibuat bisa diubah per properti di menu Promosi.")}</p>
      <div className="grid gap-4 md:grid-cols-2">
        <div><p className="text-sm font-bold">{t("Jenis promosi")}</p>
          <select data-testid="bulk-promo-kind" value={kind} onChange={(e) => setKind(e.target.value)} className="mt-1.5 h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm">
            {Object.entries(PROMO_TYPES).map(([k, v]) => <option key={k} value={k}>{t(v.title)}</option>)}
          </select></div>
        <div><p className="text-sm font-bold">{t("Properti")}</p>
          <div className="mt-1.5 flex gap-2">
            <button type="button" data-testid="bulk-promo-all" onClick={() => setAll(true)} className={`rounded-md border px-3 py-2 text-sm font-semibold ${all ? "border-[#006CE4] bg-[#006CE4]/10 text-[#006CE4]" : "border-slate-300"}`}>{t("Semua properti")} ({properties.length})</button>
            <button type="button" data-testid="bulk-promo-selected" onClick={() => setAll(false)} className={`rounded-md border px-3 py-2 text-sm font-semibold ${!all ? "border-[#006CE4] bg-[#006CE4]/10 text-[#006CE4]" : "border-slate-300"}`}>{t("Pilih properti")}</button>
          </div></div>
      </div>
      {!all && (
        <div className="grid grid-cols-1 gap-2 rounded-md border border-slate-200 p-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="bulk-promo-list">
          {properties.map((p) => (
            <label key={p.id} className="flex items-center gap-2 text-sm"><Checkbox data-testid={`bulk-promo-prop-${p.id}`} checked={sel.includes(p.id)} onCheckedChange={(v) => toggle(p.id, v)} />{p.name}</label>
          ))}
        </div>
      )}
      <div><button data-testid="bulk-promo-open" disabled={!ids.length} onClick={() => setOpen(true)} className="rounded-md bg-[#006CE4] px-5 py-2 font-semibold text-white hover:bg-[#0052B4] disabled:opacity-40">{t("Atur promosi untuk {n} properti", { n: ids.length })}</button></div>
      {result && (
        <div className="rounded-md bg-slate-50 p-3 text-sm" data-testid="bulk-promo-result">
          <p className="font-semibold text-emerald-700">{t("Berhasil")}: {result.created.map((x) => x.name).join(", ") || "—"}</p>
          {result.failed.length > 0 && <p className="mt-1 text-red-700">{t("Gagal")}: {result.failed.map((x) => `${x.name} (${x.error})`).join(", ")}</p>}
        </div>
      )}
      <PromotionDialog open={open} onOpenChange={setOpen} kind={kind} rooms={[]} plans={[]} bulkIds={ids} onSaved={setResult} />
    </div>
  );
}
